import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';

const InvoiceList = lazy(() => import('../modules/sales/invoice/pages/InvoiceList'));
const InvoiceForm = lazy(() => import('../modules/sales/invoice/pages/InvoiceForm'));
const InvoiceView = lazy(() => import('../modules/sales/invoice/pages/InvoiceView'));

const SalesRoutes = (
  <>
    <Route
      path="sales/invoice"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <InvoiceList />
        </Suspense>
      }
    />
    <Route
      path="sales/invoice/new"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <InvoiceForm />
        </Suspense>
      }
    />
    <Route
      path="sales/invoice/:id/edit"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <InvoiceForm />
        </Suspense>
      }
    />
    <Route
      path="sales/invoice/:id"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <InvoiceView />
        </Suspense>
      }
    />
  </>
);

export default SalesRoutes;
